import React from "react";
import { motion } from "framer-motion";

const RevealLinks = () => {
  return (
    <section className="flex flex-wrap justify-center gap-6  py-12 text-white font-Montserrat">
      <FlipLink href="https://twitter.com">Twitter</FlipLink>
      <FlipLink href="https://youtube.com/@kartikay7289?si=gD2GbzjnYR36hqXx">Youtube</FlipLink>
      {/* <FlipLink href="#">Facebook</FlipLink> */}
      <FlipLink href="https://www.instagram.com/hotel.crew?igsh=bms4Ym5ybnBkZGN0">Instagram</FlipLink>
    </section>
  );
};

const DURATION = 0.25;
const STAGGER = 0.025;

const FlipLink = ({ children, href }) => {
  return (
    <motion.a
      initial="initial"
      whileHover="hovered"
      href={href}
      className="relative block overflow-hidden whitespace-nowrap text-4xl font-black uppercase sm:text-7xl md:text-8xl lg:text-2xl"
      style={{
        lineHeight: 0.75,
      }}
    >
      <div>
        {children.split("").map((l, i) => (
          <motion.span
            variants={{
              initial: {
                y: 0,
              },
              hovered: {
                y: "-100%",
              },
            }}
            transition={{
              duration: DURATION,
              ease: "easeInOut",
              delay: STAGGER * i,
            }}
            className="inline-block"
            key={i}
          >
            {l}
          </motion.span>
        ))}
      </div>
      <div className="absolute inset-0">
        {children.split("").map((l, i) => (
          <motion.span
            variants={{
              initial: {
                y: "100%",
              },
              hovered: {
                y: 0,
              },
            }}
            transition={{
              duration: DURATION,
              ease: "easeInOut",
              delay: STAGGER * i,
            }}
            className="inline-block"
            key={i}
          >
            {l}
          </motion.span>
        ))}
      </div>
    </motion.a>
  );
};

export default RevealLinks;